import type { RouteResources } from '@atlassian/react-resource-router';
import { SidebarIdGlobalSystemSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalSystemSettings.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createLegacyEntry } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import type { JiraLegacyRoute } from '@jira/platform__routing-route-types/src/JiraLegacyRoute.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import { globalSettingsSystemDefaultSettingsRoute } from '@jira/router-routes__legacy-global-settings-system-default-settings-routes/src/globalSettingsSystemDefaultSettingsRoute.tsx';
import { legacyPageEntrypoint } from '@jira/router-routes__legacy-page-entrypoint/src/legacyPageEntrypoint.entrypoint.tsx';

const pageEntryPoint = createPageEntryPoint({
	main: legacyPageEntrypoint,
});

export const globalSettingsSystemDefaultSettingsRouteEntry: JiraLegacyRoute<RouteResources> =
	createLegacyEntry(globalSettingsSystemDefaultSettingsRoute, () => ({
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalSystemSettings,
		},

		resources: [navigationSidebarGlobalResource, conditionalPostOfficeJiraTopBannerResource],
		entryPoint: () => pageEntryPoint,
	}));
